// @flow
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { simpleLogout, checkConcedoToken } from 'actions/app';

import NavBar from 'components/layout/NavBar';

type Props = {
  user: {
    concedoToken: string,
  },
  children: React$Element<any>,
  location: {
    state: Object,
  },
  simpleLogout: Function,
  checkToken: Function,
};

export class AppContainer extends Component {

  componentWillReceiveProps(nextProps: Props) {
    const { user, checkToken, location } = nextProps;
    if (user.concedoToken) {
      const prevLocationState = this.props.location.state || {};
      const curlocationState = location.state || {};

      if (!prevLocationState.cohortRedirection && curlocationState.cohortRedirection) {
        return;
      }

      checkToken(user.concedoToken);
    } else {
      this.context.router.push('/login');
    }
  }

  props: Props;

  render() {
    return (
      <div className="app-container">
        <NavBar logoutHandler={this.props.simpleLogout} />
        <div className="app-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

AppContainer.contextTypes = {
  router: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.app.user || {},
  };
}

export default connect(
  mapStateToProps,
  {
    simpleLogout,
    checkToken: checkConcedoToken,
  }
)(AppContainer);



/** WEBPACK FOOTER **
 ** ./src/js/views/AppContainer.jsx
 **/